import React from 'react';
import styled from 'styled-components';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { BANNER_IMG } from '../../../lib/image/PCBackgroundImages';

const PCLeftBanner = () => {
  return (
    <BannerContainer>
      <BannerFixedBox column>
        <Text size={16}>사랑스런 우리 아기를</Text>
        <Text size={18} weight="medium">
          먼저 만나는 마법같은 순간
        </Text>
        <Text
          color="orangePink"
          size={28}
          lineHeight={1.32}
          style={{
            margin: '0.25rem 0 1rem',
            fontWeight: 900,
          }}
        >
          베이비페이스
        </Text>
        <BannerImage src={BANNER_IMG} alt="pc화면 배너 이미지" />
        <Text
          color="orangePink"
          weight="bold"
          textAlign="center"
          lineHeight={1.26}
          size={18}
          style={{ marginTop: '1.5rem' }}
        >
          베이비페이스가
          <br />
          예비 엄마 아빠에게 한 번뿐인
          <br />
          행복한 순간을 선물해 드립니다!
        </Text>
      </BannerFixedBox>
    </BannerContainer>
  );
};

export default PCLeftBanner;

const BannerContainer = styled.div`
  width: 20.5rem;
  margin-right: 4.5rem;
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

const BannerFixedBox = styled(Flex)`
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  justify-content: center;
`;

const BannerImage = styled.img`
  width: 20.5rem;
  object-fit: contain;
`;
